// app constants
import { SideBarTypes, LayoutWidth } from '../constants';

interface ConfigTypes {
    leftSideBarType:
        | SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT
        | SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED
        | SideBarTypes.LEFT_SIDEBAR_TYPE_COMPACT;
}

const getLayoutConfigs = (layoutWidth: string | boolean | null) => {
    // add property to change in particular layoutWidth
    let config: ConfigTypes = {
        leftSideBarType: SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT,
    };

    switch (layoutWidth) {
        case LayoutWidth.LAYOUT_WIDTH_FLUID:
            config.leftSideBarType = SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT;
            break;
        case LayoutWidth.LAYOUT_WIDTH_BOXED:
            config.leftSideBarType = SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED;
            break;
        default:
            return config;
    }
    return config;
};

/**
 * Changes the body attribute
 */
const changeBodyAttribute = (attribute: string, value: string | null ): void => {
    if (value !== null) {
      // Asegúrate de que el valor no sea nulo antes de establecer el atributo
      document.body.setAttribute(attribute, value);
    } else {
      // Elimina el atributo si el valor es nulo
      document.body.removeAttribute(attribute);
    }
  };

export { getLayoutConfigs, changeBodyAttribute };
